import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';


import { AppComponent } from './app.component';
import { NavBottomComponent } from './nav/nav-bottom/nav-bottom.component';
import { NavTopComponent } from './nav/nav-top/nav-top.component';
import { LeaderboardComponent } from './content/leaderboard/leaderboard.component';
import { ChallengesComponent } from './content/challenges/challenges.component';
import { SubmissionsComponent } from './content/submissions/submissions.component';
import { AppRoutingModule } from './app-routing.module';
import { ModelService } from './model.service';
import { DialogComponent } from './modal/dialog/dialog.component';
import { CombineChallengesComponent } from './modal/combine/combine-challenges/combine-challenges.component';

import { HttpClientModule } from '@angular/common/http';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { LoginComponent } from './content/login/login.component';
import { Ng2ImgMaxModule } from 'ng2-img-max';

@NgModule({
  declarations: [
    AppComponent,
    NavBottomComponent,
    NavTopComponent,
    LeaderboardComponent,
    ChallengesComponent,
    SubmissionsComponent,
    DialogComponent,
    CombineChallengesComponent,
    LoginComponent,
  ],
  imports: [
    FormsModule,
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    Ng2ImgMaxModule
  ],
  providers: [
    ModelService,
    {
      provide: LocationStrategy,
      useClass: HashLocationStrategy
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// /Users/boshaughnessy/Documents/Web/ClonkeenChallenge/clonkeen-challenge/src/app/app.module.ts